import { Directive, TemplateRef, inject } from '@angular/core';
import { AiResultContext } from './ai-runner.model';

/**
 * Apresentação livre do resultado: `<ng-template aiRunnerResult let-ctx>...</ng-template>` dentro de
 * `<ai-runner-dialog>`. Recebe o `AiResultContext` e substitui a exibição padrão.
 */
@Directive({ selector: 'ng-template[aiRunnerResult]', standalone: true })
export class AiRunnerResultDirective {
  readonly template = inject<TemplateRef<{ $implicit: AiResultContext }>>(TemplateRef);

  static ngTemplateContextGuard(
    _dir: AiRunnerResultDirective,
    ctx: unknown
  ): ctx is { $implicit: AiResultContext } {
    return true;
  }
}
